import { createRouter, createWebHistory } from 'vue-router';
// import axios from 'axios';
import Login from '../views/user/LoginView.vue';
import Register from '../views/user/RegisterView.vue';
import ChangePassword from '../views/user/ChangePasswordView.vue';
import ForgotPassword from '../views/user/ForgetPasswordView.vue';
import EditUsername from "@/views/user/EditUsernameView.vue";
import UserDashboard from '../views/user/UserDashboardView.vue';
import RecordDetail from '../views/user/RecordDetail.vue';
import ResetPwd from '@/views/user/ResetPwdView.vue';
import Contacts from '@/views/user/ContactsView.vue';

import StartAll from '@/views/StartAll.vue';
import StartMo from '@/views/estat/statmo/StatMo.vue';
import DemoStartModel from '@/views/estat/statmo/BuildModel.vue';
import DemoStartViz from '@/views/estat/statmo/VizModel.vue';
import DataFormatView from '@/views/estat/statmo/DataFormatView.vue';
import ConfigsView from "@/views/estat/statmo/ConfigsView.vue";
import StartStat from "@/views/estat/StartStat.vue"
import StartWwe from "@/views/ewwe/StartWwe.vue"

import Ebio from '@/views/ebio/ebio.vue';
import EbioChart from '@/views/ebio/ebioChart.vue';

import Edb from '@/views/edb/edb.vue';

import Eviz from '@/views/eviz/eviz.vue';

import UserStats from "@/views/about/UserStatsView.vue";
import PublicationView from "@/views/about/PublicationView.vue";


import VideoView from "@/views/about/tutorial/VideoView.vue";
import WebView from "@/views/about/tutorial/WebView.vue";
import PythonView from "@/views/about/tutorial/PythonView.vue";
import UpdateHistoryView from "@/views/about/UpdateHistoryView.vue";
import ExposomexView from "@/views/about/ExposomexView.vue";
import DownloadView from "@/views/about/DownloadView.vue";
import DatabaseVersion100 from "@/views/about/download/DatabaseVersion100.vue";
import DatabaseVersion101 from "@/views/about/download/DatabaseVersion101.vue";
import DemoDataVersion100 from "@/views/about/download/DemoDataVersion100.vue";
import DemoDataVersion101 from "@/views/about/download/DemoDataVersion101.vue";
import PeopleView from "@/views/about/PeopleView.vue";
import BingWang from "@/views/about/people/BinWang.vue";
import Mlfang from "@/views/about/people/MLFang.vue";
import LanCX from "@/views/about/people/LanCX.vue";
import ZhangGH from "@/views/about/people/ZhangGH.vue";
import RenMY from "@/views/about/people/RenMY.vue";
import GaoN from "@/views/about/people/GaoN.vue";
import LinWN from "@/views/about/people/LinWN.vue";
import FengYQ from "@/views/about/people/FengYQ.vue";

import store from '../store';

const routes = [
    { path: '/treat/:topTab?/:leftTab?', name: 'ThreatView', component: () => import('@/views/threat/ThreatView.vue'), meta: { requiresAuth: false } },
    { path: '/lcap/:topTab?/:leftTab?', name: 'LcapView', component: () => import('@/views/lcap/LcapView.vue'), meta: { requiresAuth: false } },
    { path: '/epic/:topTab?/:leftTab?', name: 'EpicView', component: () => import('@/views/epic/EpicView.vue'), meta: { requiresAuth: false } },
    { path: '/umr', name: 'UmrHome', component: () => import('@/views/umr/UmrView.vue'), meta: { requiresAuth: false } },
    { path: '/umr/:topTab?/:leftTab?', name: 'UmrView', component: () => import('@/views/umr/UmrView.vue'), meta: { requiresAuth: false } },
    { path: '/wpn/:topTab?/:leftTab?', name: 'WpnView', component: () => import('@/views/wpn/WpnView.vue'), meta: { requiresAuth: false } },
    { path: '/', name: 'index', component: StartAll, meta: { requiresAuth: false } },
    { path: '/login', name: 'Login', component: Login, meta: { requiresAuth: false } },
    { path: '/register', name: 'Register', component: Register, meta: { requiresAuth: false } },
    { path: '/change-password', name: 'ChangePassword', component: ChangePassword, meta: { requiresAuth: true } },
    { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword, meta: { requiresAuth: false } },
    { path: '/dashboard', name: 'Dashboard', component: UserDashboard, meta: { requiresAuth: true } },
    { path: '/edit-username', name: 'EditUsername', component: EditUsername, meta: { requiresAuth: true } },
    { path: '/record-detail', name: 'RecordDetail', component: RecordDetail },
    { path: '/reset-pwd', name: 'ResetPwd', component: ResetPwd },

    { path: '/contacts', name: 'Contacts', component: Contacts, meta: { requiresAuth: true } },
    { path: '/user-stats', name: 'UserStats', component: UserStats },

    { path: '/stat-mo', name: 'StartMo', component: StartMo, meta: { requiresAuth: false } },
    { path: '/start-stat', name: 'StartStat', component: StartStat, meta: { requiresAuth: false } },
    { path: '/ewwe', name: 'StartWwe', component: StartWwe, meta: { requiresAuth: false } },
    { path: '/ebio', name: 'Ebio', component: Ebio, meta: { requiresAuth: false } },
    { path: '/views/ebio/ebioChart', name: 'EbioChart', component: EbioChart, meta: { requiresAuth: false } },
    { path: '/edb', name: 'Edb', component: Edb, meta: { requiresAuth: true } },
    { path: '/eviz', name: 'Eviz', component: Eviz, meta: { requiresAuth: true } },

    { path: '/mo-model', name: 'model', component: DemoStartModel, meta: { requiresAuth: false } },
    { path: '/mo-viz', name: 'viz', component: DemoStartViz, meta: { requiresAuth: false } },
    { path: '/data-format', name: 'data-format', component: DataFormatView, meta: { requiresAuth: false } },
    { path: '/configs', name: 'configs', component: ConfigsView, meta: { requiresAuth: false } },

    { path: '/tutorials-video', name: 'tutorials-video', component: VideoView, meta: { requiresAuth: false } },
    { path: '/tutorials-web', name: 'tutorials-web', component: WebView, meta: { requiresAuth: false } },
    { path: '/tutorials-r', name: 'tutorials-r', component: PythonView, meta: { requiresAuth: false } },
    { path: '/update-history', name: 'updateHistory', component: UpdateHistoryView, meta: { requiresAuth: false } },
    { path: '/expo', name: 'expo', component: ExposomexView, meta: { requiresAuth: false } },
    { path: '/download', name: 'download', component: DownloadView, meta: { requiresAuth: false } },
    { path: '/database-version-100', name: 'database-version-100', component: DatabaseVersion100, meta: { requiresAuth: false } },
    { path: '/database-version-101', name: 'database-version-101', component: DatabaseVersion101, meta: { requiresAuth: false } },
    { path: '/demo-data-version-100', name: 'demo-data-version-100', component: DemoDataVersion100, meta: { requiresAuth: false } },
    { path: '/demo-data-version-101', name: 'demo-data-version-101', component: DemoDataVersion101, meta: { requiresAuth: false } },
    { path: '/publication', name: 'publication', component: PublicationView, meta: { requiresAuth: false } },
    { path: '/people', name: 'people', component: PeopleView, meta: { requiresAuth: false } },
    { path: '/binwang', name: 'binwang', component: BingWang, meta: { requiresAuth: false } },
    { path: '/mlfang', name: 'mlfang', component: Mlfang, meta: { requiresAuth: false } },
    { path: '/lancx', name: 'lancx', component: LanCX, meta: { requiresAuth: false } },
    { path: '/zhanggh', name: 'zhanggh', component: ZhangGH, meta: { requiresAuth: false } },
    { path: '/renmy', name: 'renmy', component: RenMY, meta: { requiresAuth: false } },
    { path: '/gaon', name: 'gaon', component: GaoN, meta: { requiresAuth: false } },
    { path: '/linwn', name: 'linwn', component: LinWN, meta: { requiresAuth: false } },
    { path: '/fengyq', name: 'fengyq', component: FengYQ, meta: { requiresAuth: false } },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
    // 如果访问需要身份验证的页面
    if (to.meta.requiresAuth) {
        // 首先检查本地存储的token
        const access_token = localStorage.getItem('access_token');
        if (!access_token) {
            // 没有token，直接重定向到登录页
            next('/login');
            return;
        }

        // 如果有token，检查当前登录状态
        if (!store.getters.isLoggedIn) {
            // 如果Vuex中没有登录状态，尝试获取登录状态
            await store.dispatch('fetchLoginStatus');
        }

        console.log("isLoggedIn" + store.getters.isLoggedIn)
        // 根据 Vuex 状态决定是否继续导航
        if (store.getters.isLoggedIn) {
            console.log("isLoggedIn next")
            next(); // 用户已登录，继续导航
        } else {
            next('/login'); // 用户未登录，重定向到登录页面
        }
    } else {
        // 对于不需要身份验证的页面，也检查一下登录状态（但不强制要求登录）
        const access_token = localStorage.getItem('access_token');
        if (access_token && !store.getters.isLoggedIn) {
            // 如果有token但Vuex中没有登录状态，尝试获取登录状态
            await store.dispatch('fetchLoginStatus');
        }
        next();
    }
});

export default router;
